import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ConfigProvider } from "@/context/ConfigContext";
import { AuthProvider } from "@/context/AuthContext";
import { PublicLayout } from "@/components/public/PublicLayout";
import { PageLoader } from "@/components/common/PageLoader";

const Home = lazy(() => import("@/pages/public/Home"));
const Apply = lazy(() => import("@/pages/public/Apply"));
const Confirmation = lazy(() => import("@/pages/public/Confirmation"));
const Privacy = lazy(() => import("@/pages/public/Privacy"));
const Terms = lazy(() => import("@/pages/public/Terms"));
const Contact = lazy(() => import("@/pages/public/Contact"));
const NotFound = lazy(() => import("@/pages/public/NotFound"));
const Login = lazy(() => import("@/pages/admin/Login"));
const ResetPassword = lazy(() => import("@/pages/admin/ResetPassword"));
const AdminLayout = lazy(() => import("@/components/admin/AdminLayout"));
const Dashboard = lazy(() => import("@/pages/admin/Dashboard"));
const Applications = lazy(() => import("@/pages/admin/Applications"));
const ApplicationDetail = lazy(() => import("@/pages/admin/ApplicationDetail"));
const Security = lazy(() => import("@/pages/admin/Security"));
const Metrics = lazy(() => import("@/pages/admin/Metrics"));
const Settings = lazy(() => import("@/pages/admin/Settings"));

function App() {
  return (
    <ConfigProvider>
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/inscricao" element={<Apply />} />
                <Route path="/inscricao/confirmacao" element={<Confirmation />} />
                <Route path="/privacidade" element={<Privacy />} />
                <Route path="/termos" element={<Terms />} />
                <Route path="/contato" element={<Contact />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin/redefinir-senha" element={<ResetPassword />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="inscricoes" element={<Applications />} />
                <Route path="inscricoes/:id" element={<ApplicationDetail />} />
                <Route path="metricas" element={<Metrics />} />
                <Route path="seguranca" element={<Security />} />
                <Route path="configuracoes" element={<Settings />} />
              </Route>
            </Routes>
          </Suspense>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" richColors />
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
